import { Link } from 'react-router-dom';
import { FC } from 'react';
import { Placeholder } from 'react-bootstrap';
import { BgOverlay } from './BgOverlay';
import { useTranslation } from 'react-i18next';

type BreadcrumbProps = {
  pageTitle: string;
  /// Breadcrumb text, if different from pageTitle.
  pageBreadcrumb?: string;
  parentBreadcrumbs?: { url: string; text: string }[];
};

export const Breadcrumbs: FC<BreadcrumbProps> = ({
  pageTitle,
  pageBreadcrumb,
  parentBreadcrumbs,
}) => {
  const { t } = useTranslation();

  return (
    <BgOverlay
      className='ltn__breadcrumb-area text-left bg-image mb-0'
      color='white'
      opacity={30}
      style={{
        backgroundImage: `url(https://rizosrealty.blob.core.windows.net/site-content/backgrounds/wide-r.jpg)`,
      }}
    >
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='ltn__breadcrumb-inner'>
              {pageTitle ? (
                <h1 className='page-title'>{pageTitle}</h1>
              ) : (
                <Placeholder
                  animation='wave'
                  as='h1'
                  style={{ width: '50%', height: '3rem' }}
                />
              )}
              <div className='ltn__breadcrumb-list'>
                <ul>
                  <li>
                    <Link to={'/'}>
                      <span>
                        <i className='fas fa-home'></i>
                      </span>
                      {t('header.home')}
                    </Link>
                  </li>
                  {parentBreadcrumbs?.map(({ url, text }) => (
                    <li key={url}>
                      <Link to={url}>{text}</Link>
                    </li>
                  ))}
                  <li>{pageBreadcrumb ? pageBreadcrumb : pageTitle}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BgOverlay>
  );
};
